import { render, staticRenderFns } from "./TimelineItem.vue?vue&type=template&id=5c5ef65f&scoped=true&"
import script from "./TimelineItem.vue?vue&type=script&lang=js&"
export * from "./TimelineItem.vue?vue&type=script&lang=js&"
import style0 from "./TimelineItem.vue?vue&type=style&index=0&id=5c5ef65f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5ef65f",
  null
  
)

export default component.exports